import { useState } from 'react';
import './UploadSheet.css';
import { checkForDuplicateLead, checkLeadDataValidity, readExcelFile } from '../../utilities/services/readExcelFile';
import { createLead } from '../../utilities/api/leads';
import { sourceOptions } from '../../utilities/services/formOptions';

export default function UploadSheet({user, getLeads, toggleNotifications}) {
    const [isFileAdded, setIsFileAdded] = useState(false)
    const [isFileParsing, setIsFileParsing] = useState(false)
    const [isFileParsedSuccessfully, setIsFileParsedSuccessfully] = useState(false)
    const [isFileValid, setIsFileValid] = useState(false)
    const [isDuplicateLeadPresent, setIsDuplicateLeadPresent] = useState(false)
    const [parsedSheetData, setParsedSheetData] = useState(null)

    const handleFileUpload = async (evt) => {
        setIsFileAdded(true)
        setIsFileValid(false)
        setIsDuplicateLeadPresent(false)
        setIsFileParsedSuccessfully(false)
        setParsedSheetData(null)
        const file = evt.target.files[0]
        if (!file) {
            setIsFileAdded(false)
            return
        }
        // console.log(file)
        setIsFileParsing(true)
        try {
            const parsedSheet = await readExcelFile(file)
            setIsFileParsedSuccessfully(true)
            const sheetValidity = checkLeadDataValidity(parsedSheet)
            const duplicateLeadPresent = checkForDuplicateLead(parsedSheet)

            sheetValidity ? setIsFileValid(true) : setIsFileValid(false)
            duplicateLeadPresent ? setIsDuplicateLeadPresent(true) : setIsDuplicateLeadPresent(false)

            if (sheetValidity && !duplicateLeadPresent) {
                parsedSheet.shift() // Remove header of table
                setParsedSheetData(parsedSheet)
            } else {
                setParsedSheetData(null)
            }
        } catch (error) {
            setIsFileParsedSuccessfully(false)
            console.log(error)
        }
        setIsFileParsing(false)
    }

    // console.log(isDuplicateLeadPresent)

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        // console.log(parsedSheetData)
        await toggleNotifications('success', 'Creating Leads...', 'black')
        try {
            const createLeadPromises = parsedSheetData.map(async (leadData) => {
                const data = {
                    ...leadData, 
                    status: 'active', 
                    canada: leadData.province ? 'y' : 'n',
                    source: sourceOptions.includes(leadData.source.toLowerCase()) ? leadData.source : leadData.source ? 'Other' : ''
                };
                await createLead(data);
            });
            await Promise.all(createLeadPromises);
            await getLeads();
            await toggleNotifications('success', 'Leads Created Successfully!')
            
        } catch (err) {
            await toggleNotifications('error', 'Failed to Create Some Leads! They may already exist.')
            await getLeads();
            console.log(err)
        }
    }

  return (
    <div className='UploadSheet modal fade' id='uploadLeadsModal'  data-bs-keyboard="true" aria-labelledby={`uploadLeadsHeader`}>
        <div className='modal-dialog'>
            <div className='modal-content'>
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                            Upload SpreadSheet of Leads
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='mainContent'>
                    <div className='sheetRequirements'>
                        <h5><u>Sheet Requirements</u></h5>
                        <ul>
                            <li><span className='requiredField'><strong>***</strong></span> Valid Formats: .csv, .xls, .xlsx</li>
                            <li>The <strong>table header</strong> must be on the <strong>first row</strong>, arranged in the same order and start at <strong>"A1"</strong>.</li>
                            <li>The <strong>Lead Name and Email are required</strong>. All other fields are optional.</li>
                            <li>Ensure there are <strong>no empty rows</strong> inbetween the sheet</li>
                            <li>For the <strong>Source</strong> column, if filled, ensure the value is on the list below:
                                <ul>
                                    <li><strong>Website, Event, Personal Contact, Referral, LinkedIn, Conference, Facebook, Instagram, Twitter, Other</strong></li>
                                </ul>
                            </li>
                            <li>For the <strong>Province</strong> column, if filled, ensure the value is on the list below:
                                <ul>
                                    <li><strong>AB, BC, MB, NB, NL, NS, NT, NU, ON, PE, QC, SK, YT</strong>.</li>
                                    <li>If the lead is <strong>not located in Canada</strong>, please leave the Province field empty.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className='sheetSample'>
                        <h5><u>Sample Sheet</u></h5>
                        <img src={require('./Sample Sheet.png')} alt="" />
                    </div>
                    <div className='fileContainer'>
                        <input type='file' className='form-control' accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileUpload} id='uploadSheet' />
                        {isFileAdded &&
                        <>
                            { isFileParsing ?
                            <div className='loading'>
                                <div className="spinner-border" role="status"></div>
                            </div>
                            :
                            <>
                            { isFileParsedSuccessfully ?
                            <div className='successText mt-3'><strong>File Parsed Successfully!</strong></div>
                            :
                            <div className='errorText mt-3'><strong>File Parsing Failed!</strong></div>
                            }
                            { (isFileParsedSuccessfully && isFileValid) ?
                            <div className='successText mt-3'><strong>Data is Valid!</strong></div>
                            :
                            <div className='errorText mt-3'><strong>Data is Invalid! Some required fields may be missing.</strong></div>
                            }
                            { (isFileParsedSuccessfully && isDuplicateLeadPresent) ?
                            <div className='errorText mt-3'><strong>Duplicate Lead(s) Found in Sheet! (Lead Name and Email must be unique.)</strong></div>
                            :
                            <div className='successText mt-3'><strong>No Duplicate Lead(s) Found in Sheet!</strong></div>
                            }
                            </>
                            }
                        </>
                        }
                    </div>
                </div>
                <div className='d-flex justify-content-center contentButtonContainer'>
                    <button data-bs-dismiss="modal" className='cancel'>Cancel</button>
                    <button data-bs-dismiss="modal" className="success submit" type="button" onClick={handleSubmit} disabled={!isFileValid || isDuplicateLeadPresent}>Create Leads</button>
                </div>
            </div>
        </div>
    </div>
  )
}
